<body [ngClass]="{'backdrop': hiddenCategory || hiddenFilter}">

    <div [ngClass]="hiddenCategory ? 'filter-category_state' : 'hidden'">

        <app-tree-view (changeItem)="eventCategoryList($event)" (hiddenCategory)="eventCloseCategory($event)" [usageSpace]="usageSpace" [categoryType]="categoryType"></app-tree-view>

    </div>

    <div [ngClass]="hiddenFilter ? 'filter-category_state filter_state' : 'hidden'">

        <app-conditions-filter [filterData]="'files'" (applyFormData)="applyFilterData($event)" (hiddenFilter)="eventCloseFilter($event)" (resetFormData)="resetFilter()"></app-conditions-filter>

    </div>

    <!-- <app-conditions-filter [filterData]="'files'" (applyFormData)="applyFilterData('filter', $event)" (resetFormData)="resetFilter()"> </app-conditions-filter> -->
    
    <div class="row">
        <!-- *ngIf="permissionAccess.check('FILE_CATEGORY_REFERENCE')"  -->
        <!-- <div [ngClass]="{'close-filter-category': filterCategoryStatus, 'col-3 open-filter-category': !filterCategoryStatus}" style="padding-right:0;">
    
            <div class="file-tree">
    
                <app-tree-view [categoryType]="categoryType" [header]="true" (changeItem)="eventCategoryList($event)"></app-tree-view>
    
            </div>
            
        </div> -->
        <!-- [ngClass]="{'col-12': (filterCategoryStatus && !fileData), 'col-10': (filterCategoryStatus && fileData), 'col-9': !fileData, 'col-7': fileData}" -->
        <!-- <div [ngClass]="{'col-12': (!fileData), 'col-9': (fileData)}"> -->
        <!-- <div [ngClass]="{'col-12': (filterCategoryStatus && !fileData), '': (!filterCategoryStatus && fileData), 'col-9': (!filterCategoryStatus && !fileData) || (filterCategoryStatus && fileData)}"> -->
            <div class="col-12">
                <div class="card card-tools">
                    <!-- <div class="title">{{ 'FILES.FILES' | translate }}</div> -->
    
                    <div class="tools">
                        <div class="tools-left">
                            <div class="btn-upload-file">
                                <ff-actions-menu
                                    *ngIf="checkedCheckBox()"
                                    class="action-menu"
                                    [countSelectedFiles]="countSelectedFiles"
                                    [actionListData]="actionsList"
                                    [listData]="files"
                                    (changeValue)="getList()"
                                    (deletedData)="onDelete($event)">
                                </ff-actions-menu>
                            </div>
                            <div class="btn-upload-file">
                                <button type="button"
                                    [ngClass]="{'ml-0': !checkedCheckBox()}"
                                    class="btn btn-tools btn-light btn-sm btn-category" (click)="hiddenCategory = !hiddenCategory">
                                    <svg-icon src="/assets/images/icons/category.svg" [stretch]="true"
                                    [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                    <!-- <i class="bi category-icon"><img class="th-icon"
                                        src="/assets/images/icons/category.svg"></i> -->
                                    <span class="btn-span">{{ 'FILES.CATEGORIES' | translate }}</span>
                                </button>
                            </div>
                            <button type="button" class="btn btn-tools btn-light btn-sm btn-category" (click)="hiddenFilter = !hiddenFilter">
                                <!-- <i class="bi category-icon"><img class="th-icon" src="/assets/images/icons/filter2.svg"></i> -->
                                <svg-icon src="/assets/images/icons/filter2.svg" [stretch]="true"
                                [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                <span class="btn-span">{{ 'Фильтр' | translate }}</span>
                            </button>
                        </div>
                        <div class="tools-right">
                            <div class="btn-upload-file">
                                <button type="button" class="btn btn-primary btn-sm" (click)="uploadFile()">
                                    <!-- <i class="bi bi-download"></i>  -->
                                    <svg-icon src="/assets/images/icons/add.svg" [stretch]="true"
                                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                    <span>Загрузить файл</span> 
                                </button>
                            </div>
                            <button type="button" class="btn-right p-0"  placement="left" tooltipClass="clue-name" ngbTooltip="Сбросить" placement="left" class="btn btn-none btn-sm"
                            (click)="resetFilter()">
                                <svg-icon class="mr-0" src="/assets/images/icons/refresh.svg" [stretch]="true"
                                [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                        </button>
    
                        </div>
    
    
                        <!-- <ff-button-upload-files label="{{ 'UPLOAD_FILE' | translate }}"
                            [multiple]="btnUploadFilesMultiple" (uploadedFiles)="getList()">
                        </ff-button-upload-files> -->
                        <!--  *ngIf="permissionAccess.check('CREATE_FILE')" -->
                    </div>
                </div>
            </div>

        <div [ngClass]="{'col-12': (!fileData), 'col-9': (fileData)}">
    

            <div class="card card-inner-files">
    
                <div class="card-body card-body_table-files">
    
                    <!-- HIDE/EXPAND SIDEBAR BUTTON -->
                    <!-- <div class="sidebar-button" [ngClass]="{'close-sidebar': filterCategoryStatus}">
                        <div class="btn-expand" type="button" (click)="toggleCategoryBox()">
                        <i class="bi bi-chevron-left"></i>
                        </div>
                    </div> -->
    
                    <!-- <div class="counter-files">
                        <button type="button" class="btn btn-primary btn-sm" (click)="chooseAllFiles()">
                            <i class="bi-check2-square"></i>{{ 'FILES.SELECTED_ALL_FILES' | translate }}
                        </button>
                        <button type="button" class="btn btn-primary btn-sm" (click)="unChooseAllFiles()">
                            <i class="bi-x-square"></i>{{ 'FILES.UNSELECTED_ALL_FILES' | translate }}
                        </button>
                        <div class="counter-label">{{ 'FILES.SELECTED_FILES' | translate }}: {{countSelectedFiles}}</div>
                    </div> -->
                    
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col" class="checkbox">
                                    <div class="btn-group me-3">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" name="select_all_files"
                                                id="select_all_files" [checked]="checkedCheckBox()"
                                                [indeterminate]="checkedButNotAllCheckBox()"
                                                (change)="checkAllCheckBox($event)">
                                            <label class="custom-control-label" for="select_all_files"></label>
                                        </div>
                                        <div class="btn-group" ngbDropdown role="group">
                                            <button type="button" class="btn btn-dropdown dropdown-toggle-split" ngbDropdownToggle></button>
                                            <div class="dropdown-menu" ngbDropdownMenu>
                                                <button ngbDropdownItem>
                                                    <span (click)="chooseAllFiles()">
                                                        {{ 'PRODUCT.SELECTED_ALL_PRODUCTS' | translate }}
                                                    </span>
                                                </button>
                                                <button ngbDropdownItem>
                                                    <span (click)="unChooseAllFiles()">
                                                        {{ 'PRODUCT.UNSELECTED_ALL_PRODUCTS' | translate }}
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </th>
                                <th scope="col" class="name" (click)="sortData('name')">
                                    <!-- <i *ngIf="checkDirection('name') == '' || sort[i] == null" class="bi bi-arrow-down-up"></i>
                                    <i *ngIf="checkDirection('name') == 'asc'" class="bi bi-arrow-up"></i>
                                    <i *ngIf="checkDirection('name') == 'desc'" class="bi bi-arrow-down"></i> -->
                                    {{ 'Наименование файла' | translate }}
                                </th>
                                <th scope="col" class="date">{{'FILES.DATE_OF_CREATE' | translate }}</th>
                                <th scope="col" class="status">{{'STATUS' | translate }}</th>
                                <th scope="col" class="action"></th>
                            </tr>
                        </thead>
    
                        <tbody *ngIf="files.length > 0">
                            <tr *ngFor="let file of files; let i = index">
                                <td class="checkbox">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox" name="select_file_{{ i }}"
                                            id="select_file_{{ i }}" [checked]="file.checked"
                                            (change)="selectedCheckBox(i, $event)">
                                        <label class="custom-control-label" for="select_file_{{ i }}"></label>
                                    </div>
                                </td>
    
                                <td class="name cursor" (click)="getFileInfo(file.id)"><img class="file-icon"
                                        src="/assets/images/file_icons/png/{{ checkIconExt(file.name) }}.png">{{ file.name}}</td>
    
                                <td class="date cursor" (click)="getFileInfo(file.id)">{{ file.create_date | date: 'dd.MM.yyyy HH:mm' }} </td>

                                <td class="status">
                                    <div class="state" [ngClass]="file.state_id.toLowerCase()">
                                        {{ translateState(file.state_id) }}
                                    </div>
                                </td>
    
                                <td class="action">
                                    <div class="action-btn">
                                        <!-- btn download file -->
                                        <button type="button" class="btn btn-none btn-download btn-sm"
                                            *ngIf="permissionAccess.check('DOWNLOAD_ONE_FILE')"
                                            (click)="downloadFile(file.id, file.name)"
                                            ngbTooltip="{{ 'DOWNLOAD' | translate }}" placement="left" tooltipClass="clue-name">
                                            <!-- <i class="bi bi-download"></i> -->
                                            <svg-icon class="" src="/assets/images/icons/download.svg" [stretch]="true"
                                            [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                        </button>
                                        <section class="action-btn_list">
    
                                            <ng-template class="btn-list" #popContent>
                                                
                                                <!-- btn profile -->
                                                <div class="btn-list_item"
                                                    (click)="getProfile(file.id)">
                                                    <span>{{ 'WATCH' | translate }}</span>
                                                </div>

                                                <!-- btn link -->
                                                <div class="btn-list_item"
                                                    *ngIf="permissionAccess.check('ADD_FILE_TO_CATEGORY')"
                                                    (click)="addFileToCategory(file.id, file.category_id)">
                                                    <span>{{ 'FILES.BIND' | translate }}</span>
                                                </div>
    
                                                <!-- btn delete file -->
                                                <div class="list-item_delete"
                                                *ngIf="permissionAccess.check('ORGS_FILES_DELETE')"
                                                    (click)="onDelete(file.id)">
                                                    <span>{{ 'Удалить' | translate }}</span>
                                                </div>
    
                                            </ng-template>
    
                                            <button type="button" placement="left" [ngbPopover]="popContent"
                                                [autoClose]="true" triggers="manual" #p="ngbPopover"
                                                class="btn btn-none action-btn_active btn-sm"
                                                (click)="openWindowWithButton(p)"
                                                ngbTooltip="Действия">
                                                <svg-icon class="" src="/assets/images/icons/actions-more.svg" [stretch]="true"
                                                [svgStyle]="{'width.px':18, 'height.px':18}"><i class="bi bi-three-dots-vertical"></i> </svg-icon>
                                            </button>
                                        </section>
    
                                        <!-- btn link -->
                                        <!-- <button type="button" class="btn btn-light" (click)="addFileToCategory(file.id, file.category_id)" ngbTooltip="{{ 'FILES.BIND' | translate }}">
                                            <i class="bi bi-link-45deg btn-link-info"></i>
                                        </button> -->
                                        <!-- btn profile -->
                                        <!-- <button type="button" class="btn btn-light" (click)="getProfile(file.id)"
                                            placement="top" ngbTooltip="{{ 'WATCH' | translate }}">
                                            <i class="bi bi-eye"></i>
                                        </button> -->
                                        <!-- btn delete file -->
                                        <!-- <button type="button" class="btn btn-light" (click)="onDelete(file.id)"
                                            *ngIf="permissionAccess.check('ORGS_FILES_DELETE')" placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                            <i class="bi bi bi-trash"></i>
                                        </button> -->

                                    </div>
                                </td>
                            </tr>
    
                        </tbody>
    
                        <tbody *ngIf="files.length == 0">
                            <tr>
                                <td *ngIf="loading" class="data-loading" colspan="4">
                                    <div class="spinner-bars">
                                        <div class="loadingio-spinner-bars-preLoder-inner">
                                            <div class="preLoder">
                                                <div></div><div></div><div></div><div></div>
                                            </div>
                                        </div>
                                        <div>{{ 'LOADING' | translate }}</div>
                                    </div>
                                </td>
                                <td *ngIf="!loading" class="data-not-found" colspan="4">
                                    <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

        </div>

        <div [ngClass]="{'col-3 card-info': fileData}" *ngIf="fileData">

            <!-- <app-file-info></app-file-info> -->
    
            <!-- File-info -->
            <div class="content content-position">
    
                <!-- File-info-foto -->
    
                <div class="">
                    <div class="close-file-data">
                       <!-- <i class="bi bi-x-circle btn-light" (click)="fileData = null" ></i> -->
                       <!-- <button type="button" class="btn btn-none" (click)="fileData = null">
                        <i class="bi bi-x-lg"></i>
                        </button> -->
                        <button type="button" class="close" aria-label="Close" (click)="fileData = null">
                            <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                        </button>
                    </div>
                    <div class="block-product_img">
                    <!-- <div class="img-file-info block-photo"> -->
                        <div class="product-img" *ngIf="(fileData.extension == 'jpg' || fileData.extension == 'png' || fileData.extension == 'jpeg' || fileData.extension == 'png') && fileLink != null">
                            <img class="product-img_sze" src="{{ fileLink }}">
                        </div>
                        <div class="product-img block-no-photo" *ngIf="(fileData.extension != 'jpg' && fileData.extension != 'png' && fileData.extension != 'jpeg' && fileData.extension != 'png') || fileLink == null">
                            <img src="/assets/images/icons/no-photo.svg" class="product-img_sze">
                        </div>
                    </div>
                </div>
    
    
                <!-- File-info-link -->
    
                <div class=" btn-position" *ngIf="fileData">
                    <!-- File-edit -->
                    <button *ngIf="permissionAccess.check('UPDATE_FILE')" type="button" class="btn btn-download btn-none"  tooltipClass="clue-name" (click)="onEdit(fileData.file_id)"
                        ngbTooltip="{{ 'EDIT' | translate }}">
                        <!-- <i class="bi bi-pencil-square btn-link-info"></i> -->
                        <svg-icon class="" src="/assets/images/icons/edit.svg" [stretch]="true"
                        [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                    </button>
    
                    <!-- Link-file -->
                    <button *ngIf="permissionAccess.check('ADD_FILE_TO_CATEGORY')" type="button" class="btn btn-download btn-none"
                    tooltipClass="clue-name" (click)="addFileToCategory(fileData.file_id, fileData.category_id)" ngbTooltip="{{ 'FILES.BIND' | translate }}">
                        <!-- <i class="bi bi-link-45deg btn-link-info"></i> -->
                        <svg-icon class="" src="/assets/images/icons/link.svg" [stretch]="true"
                        [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                    </button>
    
                    <!-- Download-file -->
                    <button type="button" class="btn btn-download btn-none" *ngIf="permissionAccess.check('DOWNLOAD_ONE_FILE')"
                    tooltipClass="clue-name" (click)="downloadFile(fileData.file_id, fileData.name)"
                        ngbTooltip="{{ 'DOWNLOAD' | translate }}">
                        <!-- <i class="bi bi-download btn-link-info"></i> -->
                        <svg-icon class="" src="/assets/images/icons/download.svg" [stretch]="true"
                        [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                    </button>

                    <button type="button" class="btn btn-download btn-none"  tooltipClass="clue-name" (click)="getProfile(fileData.file_id)"
                    ngbTooltip="{{ 'WATCH' | translate }}">
                    <!-- <i class="bi bi-pencil-square btn-link-info"></i> -->
                    <svg-icon class="" src="/assets/images/icons/eye.svg" [stretch]="true"
                    [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                </button>
                </div>
    
                <!-- File-info-text -->
                <div class=" card-info-text">
                    <div class="row">
                        <div class="col-12">
                            <!-- {{fileData.name}} -->
                            <div class="product-info-title"> {{fileData.name}} </div>
                        </div>
                    </div>
    
                    <div class="row">
                        <div class="col-6">
                            <div class="notification-info-title">{{ 'FILES.DATE_OF_CREATE' | translate }}:</div>
                        </div>
                        <div class="col-6">
                            <div class="org-info-value">
                                {{ fileData.create_date | date: 'dd.MM.yyyy HH:mm' }}
                            </div>
                        </div>
                    </div>
    
                    <div class="row">
                        <div class="col-6">
                            <div class="notification-info-title">{{ 'FILES.CREATER' | translate }}:</div>
                        </div>
                        <div class="col-6">
                            <div class="org-info-value">
                                {{fileData.create_user}}
                            </div>
                        </div>
                    </div>
    
                    <!-- <div class="row">
                        <div class="">
                            <div class="notification-info-title">{{ 'FILES.DATE_OF_EDIT' | translate }}:</div>
                        </div>
                        <div class="">
                            <div class="org-info-value"></div>
                        </div>
                    </div>
    
                    <div class="row">
                        <div class="">
                            <div class="notification-info-title">{{ 'FILES.EDITOR' | translate }}:</div>
                        </div>
                        <div class="">
                            <div class="org-info-value">
    
                            </div>
                        </div>
                    </div> -->
    
                    <div class="row">
                        <div class="col-6">
                            <div class="notification-info-title">{{ 'SIZE' | translate }}:</div>
                        </div>
                        <div class="col-6">
                            <div class="org-info-value">
                                {{convertationToMb(fileData.size)}}
                            </div>
                        </div>
                    </div>
    
                    <div class="row">
                        <div class="col-6">
                            <div class="notification-info-title">{{ 'FORMAT' | translate }}:</div>
                        </div>
                        <div class="col-6">
                            <div class="org-info-value">
                                {{fileData.extension}}
                            </div>
                        </div>
                    </div>
    
                    <div class="row">
                        <div class="col-6">
                            <div class="notification-info-title">Срок действия файла:</div>
                        </div>
                        <div class="col-6">
                            <div class="org-info-value">
                                <span *ngIf="fileData.meta != null && fileData.meta.valid_to != null">{{ fileData.meta.valid_to | date: 'dd.MM.yyyy'}}</span>
                                <span *ngIf="fileData.meta == null || fileData.meta.valid_to == null">Нет данных</span>
                            </div>
                        </div>
                    </div>
    
                    <div class="row">
                        <div class="col-6">
                            <div class="notification-info-title">Категория:</div>
                        </div>
                        <div class="col-6">
                            <div class="org-info-value">
                                <span *ngIf="fileData.category_name != null">{{fileData.category_name}}</span>
                                <span *ngIf="fileData.category_name == null">Нет данных</span>
                            </div>
                        </div>
                    </div>
    
    
                    <!-- <div class="row">
                        <div class="">
                            <div class="notification-info-title">{{ 'ACCESS' | translate }}:</div>
                        </div>
                        <div class="">
                            <div class="org-info-value">
    
                            </div>
                        </div>
                    </div>
    
                    <div class="row">
                        <div class="">
                            <div class="notification-info-title">{{ 'FILES.SHELF_LIFE' | translate }}:</div>
                        </div>
                        <div class="">
                            <div class="org-info-value">
    
                            </div>
                        </div>
                    </div>
    
                    <div class="row">
                        <div class="">
                            <div class="notification-info-title">{{ 'FILES.LINK_RULES' | translate }}:</div>
                        </div>
                        <div class="">
                            <div class="org-info-value">
    
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
    
        </div>
        </div>

        <div class="col-12">
            <div class="card-footer-pagination">
                <div class="pagination-component-files">
                    <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
                </div>
            </div>
        </div>
    

    </div>

</body>

